
import Vue from "vue";

import dialogCom from "@/components/ModelCom.vue";
import Utils from "@/assets/js/Utils";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
export default Vue.extend({
  components: { dialogCom },
  data() {
    return {
      dialog: null as any,
      logs: [] as any[],
      alarms: [] as any[],
      currentId: "run",
      count: 50,
      page: 0,
      page1: 0,
      page2: 0,
      runs: [] as any[],
      sid: "" as string,
    };
  },
  mounted() {
    this.dialog = this.$refs.dialog;
    this.page = 0;
    this.page1 = 0;
    this.page2 = 0;
    this.handleClick();
  },
  methods: {
    opened() {
      this.$emit("opened");
    },
    show(sid: string) {
      this.sid = sid;
      this.page = 0;
      this.page1 = 0;
      this.page2 = 0;
      this.logs = [];
      this.alarms = [];
      this.runs = [];
      this.currentId = "run";
      this.dialog.show();
      this.handleClick();
    },
    hiden() {
      this.dialog.hiden();
    },
    more(type: number) {
      console.log(type, "teset");
      if (type == 0) {
        this.page += 1;
        this.selectLog();
      } else if (type == 1) {
        this.page1 += 1;
        this.selectAlarm();
      } else if (type == 2) {
        this.page2 += 1;
        this.selectRun();
      }
    },
    async selectRun() {
      let obj = {
        count: this.count,
        skip: this.page2 * this.count,
        sid: this.sid,
      };
      console.log(obj, "objtest");
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetGatewayRunSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.runs.push(x);
      });
      console.log(this.runs);
    },
    async selectLog() {
      let obj = {
        count: this.count,
        skip: this.page * this.count,
        sid: this.sid,
      };
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetGatewayLogSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.logs.push(x);
      });
    },
    async selectAlarm() {
      let obj = {
        count: this.count,
        skip: this.page * this.count,
        sid: this.sid,
      };
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      obj.skip = this.page1 * this.count;
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetDeviceAlarmSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.alarms.push(x);
      });
    },
    async handleClick() {
      console.log(this.currentId);
      if (this.currentId == "log") {
        this.page = 0;
        this.logs = [];
        await this.selectLog();
      } else if (this.currentId == "alarm") {
        this.page1 = 0;
        this.alarms = [];
        await this.selectAlarm();
      } else if (this.currentId == "run") {
        this.page2 = 0;
        this.runs = [];
        await this.selectRun();
      }
    },
  },
});
